
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";

const IntroSection = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-secondary/20 to-background">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="space-y-12 reveal">
          <div className="prose max-w-none">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
              <Card className="col-span-1 md:col-span-2 bg-white/70 backdrop-blur-sm">
                <CardContent className="pt-6">
                  <p className="text-lg leading-relaxed">
                    It used to be about <span className="font-medium text-accent">endless excel sheets</span>. Then we, the white collar army (often in surf shorts) have evolved into <span className="font-medium">automated BI reporting</span>. Great move forward, but comes with disadvantages.
                  </p>
                  
                  <div className="my-6 pl-4 border-l-2 border-primary/50">
                    <p className="italic text-muted-foreground">Our colleagues often get lost in the reports. Some are more innovative and tech savvy than others, for the laggards it can get tedious and exhausting to get the answer they need.</p>
                  </div>
                </CardContent>
              </Card>
              
              <Card className="col-span-1 bg-primary/5 border-primary/20">
                <CardContent className="pt-6 flex items-center h-full">
                  <p className="font-medium text-xl text-center">
                    Everyone who has built a reporting system knows the challenge of <span className="text-accent">maintaining user adoption</span>.
                  </p>
                </CardContent>
              </Card>
            </div>
            
            <div className="bg-white/70 backdrop-blur-sm p-6 rounded-xl border border-border shadow-md mb-10">
              <p className="text-lg text-center font-medium mb-4">
                That is not what this is about.
              </p>
              
              <div className="text-center max-w-2xl mx-auto">
                <p className="text-xl md:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-accent to-primary mb-6">
                  We are thrilled to apply the technology of today to move how humans interact with information another leap forward.
                </p>
                
                <div className="inline-block bg-secondary py-2 px-4 rounded-full text-lg font-medium">
                  We are here to help you talk to your data!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
